import { fetcher } from '@commenda/utils';

export async function createExtensionForCompliance({
  complianceItemId,
}: {
  complianceItemId: string;
}) {
  const res = await fetcher(`compliance/${complianceItemId}/extension`, {
    method: 'POST',
  });

  return res.json();
}
